<ui-side-sheet>
  <div class="content">
    @if (!isFullscreenRoute()) {
      <ui-app-store-banner></ui-app-store-banner>
      <ui-agent-status-bar></ui-agent-status-bar>
      <div class="wrapper-header">
        @if (!isOverlayRoute() && infobarConfig(); as config) {
          <ui-cms class="infobar" [config]="config"></ui-cms>
        }

        <ui-cep-header
          (barcodeClicked)="openBarcodeScanner()"
          (searchSubmit)="cepStateService.navigateToSearch($event)"
          (searchFieldClicked)="openMobileSearchOverlay()"
          [searchTextValue]="searchTextValue()"
          class="header"
        >
        </ui-cep-header>

        @if (authorized() && isCurrentCustomerBlocked()) {
          <ui-blocked-customer-info></ui-blocked-customer-info>
        }
      </div>
    }

    <div #wrapperContent class="wrapper-content">
      @if (!isFullscreenRoute() && isDesktopXl()) {
        <ui-desktop-navigation class="navigation"></ui-desktop-navigation>
      }
      
      <div
        [class.overlay-route]="isOverlayRoute() || isFullscreenRoute()"
        class="wrapper-dynamic-content">
        <div class="wrapper-router-outlet">
          @if (!authorized() || customer()) {
            <router-outlet></router-outlet>
          }
        </div>

        @if (!isOverlayRoute() && !isFullscreenRoute()) {
          <ui-cep-footer [authorized]="authorized()"></ui-cep-footer>
        }
      </div>

      @if (isScannerFABVisible()) {
        <button (click)="openBarcodeScanner()" class="btn-scanner" mat-fab>
          <ui-icon faName="barcode" faStyle="solid"></ui-icon>
        </button>
      }
    </div>

    @if (!isDesktopXl() && authorized() && !isFullscreenRoute()) {
      <div class="wrapper-mobile-navbar">
        <ui-navbar></ui-navbar>
      </div>
    }
  </div>
</ui-side-sheet>
